import { parse } from "date-fns";

export class DateUtils {
  /*
   * Convert Date string to Date using the format
   * @param dateString Example: 2023-03-28 09:00:00+00:00
   * @param format Example: yyyy-MM-dd HH:mm:ssXXX
   */
  static parse(dateString: string, format: string): Date {
    return parse(dateString, format, new Date());
  }
}
